import { render, staticRenderFns } from "./positionCoefficient.vue?vue&type=template&id=f942242e&scoped=true&"
import script from "./positionCoefficient.vue?vue&type=script&lang=js&"
export * from "./positionCoefficient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f942242e",
  null
  
)

export default component.exports